import { render, staticRenderFns } from "./aOrderDetailEvent.vue?vue&type=template&id=6dc5f079&scoped=true"
import script from "./aOrderDetailEvent.vue?vue&type=script&lang=js"
export * from "./aOrderDetailEvent.vue?vue&type=script&lang=js"
import style0 from "./aOrderDetailEvent.vue?vue&type=style&index=0&id=6dc5f079&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dc5f079",
  null
  
)

export default component.exports